/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceBandRequest
 */
export interface PriceBandRequest {
    /**
     * 
     * @type {number}
     * @memberof PriceBandRequest
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceBandRequest
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceBandRequest
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceBandRequest
     */
    max?: number;
}

export function PriceBandRequestFromJSON(json: any): PriceBandRequest {
    return PriceBandRequestFromJSONTyped(json, false);
}

export function PriceBandRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceBandRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'percentage': !exists(json, 'percentage') ? undefined : json['percentage'],
        'min': !exists(json, 'min') ? undefined : json['min'],
        'max': !exists(json, 'max') ? undefined : json['max'],
    };
}

export function PriceBandRequestToJSON(value?: PriceBandRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'percentage': value.percentage,
        'min': value.min,
        'max': value.max,
    };
}


